import React, { useEffect, useState } from "react"
import "./Services.css"
import { AuroraText } from "../components/magicui/aurora-text"
import { BlurFade } from "../components/magicui/blur-fade"
import { useTranslation } from "react-i18next"
import { NumberTicker } from "../components/magicui/number-ticker"
import building from "../assets/building_illustration.webp"
import avatar_cs1 from "../assets/avatar_cs1.webp"
import avatar_cs2 from "../assets/avatar_cs2.webp"
import video2 from "../assets/videoservices.mp4"
import { Orbit } from "../components/Orbit"
import logo from "../assets/logo.png"

const Services = () => {

    const { t, i18n } = useTranslation()
    const [selectedFAQ, setSelectedFAQ] = useState()
    const [containerHeights, setContainerHeights] = useState([])
    const [faqContainerHeight, setFaqContainerHegith] = useState()

    useEffect(() => {
        
        const heights = []

        document.querySelectorAll(".txt-faq-response").forEach((m) => {
        heights.push(m.scrollHeight)
        })

        setContainerHeights(heights)
        setFaqContainerHegith(document.querySelector(".container-faq-n-ans").offsetHeight + Math.max(...heights))
    }, [])


    return (
        <div className="space-y-52 mb-10">
            <div className="services-hero">
                <video className="services-video" autoPlay loop muted playsInline>
                    <source src={video2} type="video/mp4" />
                </video>
                <div className="services-overlay">
                    <h1>{t('services.hero.title')}</h1>
                    <p>{t('services.hero.text')}</p>
                </div>
                <svg className="services-hero-curve" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 150" preserveAspectRatio="none">
                    <path d="M0,0 C480,150 960,150 1440,0 L1440,150 L0,150 Z" fill="white" />
                </svg>
                
            </div>
            <div className={`more-details-services ${i18n.language === "ar" ? "ar-rtl" : ""}`}>
                <div className="left-container-mds">
                    <div>
                        <h2 className={`title-left-container-mds ${i18n.language.split("-")[0] === "ar" ? "txt-right-align" : ""}`}>
                            {t('services.sections.section_one.title')}
                        </h2>
                    </div>
                    <div className="image-under-title-mds"></div>
                </div>
                <div className="right-container-mds">
                    <div className="image-right-title-mds"></div>
                    <div className="right-text-info">
                        <div className="child-container-info">
                            <div className={`${i18n.language === "ar" ? "icon-mds-info-ar" : "icon-mds-info"}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3d3d3d" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chart-no-axes-column-increasing-icon lucide-chart-no-axes-column-increasing"><line x1="12" x2="12" y1="20" y2="10"/><line x1="18" x2="18" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="16"/></svg>
                            </div>
                            <div>
                                <p>
                                    {t('services.sections.section_one.info.box_one')}
                                </p>
                            </div>
                        </div>
                        <div className="child-container-info">
                            <div className={`${i18n.language === "ar" ? "icon-mds-info-ar" : "icon-mds-info"}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3d3d3d" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chart-pie-icon lucide-chart-pie"><path d="M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z"/><path d="M21.21 15.89A10 10 0 1 1 8 2.83"/></svg>
                            </div>
                            <div>
                                <p>
                                    {t('services.sections.section_one.info.box_two')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="show-services-container [mask-image:_linear-gradient(to_bottom,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
                <div className={`parent-srv-ct ${i18n.language === "ar" ? "ar-rtl" : ""}`}>
                    <div className="ch-srv-c">
                        <div className="feature-service-box">
                        <div className="child-feature-srv">
                            <div className="mini-title-srv">
                                {t('services.sections.section_two.list.element_one.mini_title')}
                            </div>
                            <div className="title-srv">
                               {t('services.sections.section_two.list.element_one.title')}
                            </div>
                            <div className="txt-description-srv">
                                {t('services.sections.section_two.list.element_one.text')}
                            </div>
                        </div>
                        </div>
                        <div className="feature-service-box">
                            <div className="child-feature-srv">
                                <div className="mini-title-srv">
                                    {t('services.sections.section_two.list.element_two.mini_title')}
                                </div>
                                <div className="title-srv">
                                    {t('services.sections.section_two.list.element_two.title')}
                                </div>
                                <div className="txt-description-srv">
                                    {t('services.sections.section_two.list.element_two.text')}
                                </div>
                            </div>
                        </div>
                        <div className="feature-service-box">
                            <div className="child-feature-srv">
                                <div className="mini-title-srv">
                                    {t('services.sections.section_two.list.element_three.mini_title')}
                                </div>
                                <div className="title-srv">
                                {t('services.sections.section_two.list.element_three.title')}
                                </div>
                                <div className="txt-description-srv">
                                    {t('services.sections.section_two.list.element_three.text')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right-side-srv">
                        <div className="container-orbit-right">
                                        <Orbit
                                        durationSeconds={40}
                                        radiusPx={140}
                                        keepUpright
                                        orbitingObjects={[
                                            <div
                                            key="obj1"
                                            className="relative  flex items-center justify-center"
                                            >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-wrench-icon lucide-wrench"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
                                            <div className="absolute size-10 rounded-full bg-white/50 ring-1 shadow-lg ring-black/5"></div>
                                            
                                            <div
                                                style={{
                                                animationDelay: "1s",
                                                }}
                                                className="absolute size-10 animate-[ping_7s_ease_infinite] rounded-full ring-1 ring-orange-500/50"
                                            ></div>
                                            </div>,
                        
                                            <div
                                            key="obj2"
                                            className="relative flex items-center justify-center"
                                            >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-graduation-cap-icon lucide-graduation-cap"><path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"/><path d="M22 10v6"/><path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"/></svg>
                                            <div className="absolute size-10 rounded-full bg-white/50 ring-1 shadow-lg ring-black/5"></div>
                                            
                                            <div
                                                style={{
                                                animationDelay: "4s",
                                                }}
                                                className="absolute size-10 animate-[ping_7s_ease_infinite] rounded-full ring-1 ring-orange-500/50"
                                            ></div>
                                            </div>,
                        
                                            <div
                                            key="obj3"
                                            className="relative flex items-center justify-center"
                                            >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-library-big-icon lucide-library-big"><rect width="8" height="18" x="3" y="3" rx="1"/><path d="M7 3v18"/><path d="M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z"/></svg>
                                            <div className="absolute size-10 rounded-full bg-white/50 ring-1 shadow-lg ring-black/5"></div>
                                            <div
                                                style={{
                                                animationDelay: "2s",
                                                }}
                                                className="absolute size-10 animate-[ping_7s_ease_infinite] rounded-full ring-1 ring-orange-500/50"
                                            ></div>
                                            </div>,
                                            <div
                                            key="obj4"
                                            className="relative flex items-center justify-center"
                                            >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-cpu-icon lucide-cpu"><path d="M12 20v2"/><path d="M12 2v2"/><path d="M17 20v2"/><path d="M17 2v2"/><path d="M2 12h2"/><path d="M2 17h2"/><path d="M2 7h2"/><path d="M20 12h2"/><path d="M20 17h2"/><path d="M20 7h2"/><path d="M7 20v2"/><path d="M7 2v2"/><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="8" y="8" width="8" height="8" rx="1"/></svg>
                                            <div className="absolute size-10 rounded-full bg-white/50 ring-1 shadow-lg ring-black/5"></div>
                                            
                        
                                            <div
                                                style={{
                                                animationDelay: "6s",
                                                }}
                                                className="absolute size-10 animate-[ping_7s_ease_infinite] rounded-full ring-1 ring-orange-500/50"
                                            ></div>
                                            </div>,
                                            <div
                                            key="obj5"
                                            className="relative flex items-center justify-center"
                                            >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-blocks-icon lucide-blocks"><path d="M10 22V7a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1H2"/><rect x="14" y="2" width="8" height="8" rx="1"/></svg>
                                            <div className="absolute size-10 rounded-full bg-white/50 ring-1 shadow-lg ring-black/5"></div>
                                            <div
                                                style={{
                                                animationDelay: "3s",
                                                }}
                                                className="absolute size-10 animate-[ping_7s_ease_infinite] rounded-full ring-1 ring-orange-500/50"
                                            ></div>
                                            </div>,
                                        ]}
                                        >
                                        <div className="relative flex h-48 w-48 items-center justify-center">
                                            <div className="rounded-full p-1 ring-1 ring-black/10">
                                            <div className="relative z-10 flex size-20 items-center justify-center rounded-full bg-white ring-1 shadow-[inset_0px_-15px_20px_rgba(0,0,0,0.1),0_7px_10px_0_rgba(0,0,0,0.15)] ring-black/15">
                                                <img src={logo} width={55} height={55} alt="logo" />
                                            </div>
                                            <div className="absolute inset-12 animate-[spin_8s_linear_infinite] rounded-full bg-linear-to-t from-transparent via-orange-400 to-transparent blur-lg" />
                                            </div>
                                        </div>
                                        </Orbit>
                                    </div>
                    </div>
                    
                </div>
            </div>
            <div className={`container-illustration-sct ${i18n.language === "ar" ? "ar-rtl" : ""}`}>
                <div className="container-illustration-1">
                    <h2 className="txt-title-illustration">
                        {t('services.sections.section_three.title')} <AuroraText>{t('services.sections.section_three.title_special')}</AuroraText>
                    </h2>
                </div>
                <div className="container-illustration-2">
                    <img loading="lazy" className="image-illustration-sct" alt="Building" src={building} />
                </div>
            </div>
            <div className="services-container-stats-top">
                <div className="parent-container-stats-top">
                    <div className="top-sct-stats">
                        <div className="txt-stats-top">
                            <div>
                                <BlurFade delay={0.25} inView> 
                                    <h2 className="title-sct-stats">
                                        {t('services.sections.section_four.top.title')} <span className="gray-color-txt-sct">{t('services.sections.section_four.top.title_special')}</span>
                                    </h2>
                                </BlurFade>
                            </div>
                            <div>
                                <BlurFade delay={0.30} inView> 
                                    <p className="paragraph-sct-stats-top">
                                        {t('services.sections.section_four.top.text')}
                                    </p>
                                </BlurFade>
                            </div>
                        </div>
                        <div className="container-lst-top">
                            <div className="image-container-sct-stats">
                                <BlurFade delay={1} className="first-image-container" inView>
                                </BlurFade>
                                <BlurFade delay={0.75} className="second-image-container" inView>
                                </BlurFade>
                                <BlurFade delay={0.50} className="third-image-container" inView> 
                                </BlurFade> 
                            </div>
                            <div>
                                <BlurFade delay={0.50} inView> 
                                    <p className="paragraph-sct-stats-under-images">
                                        <span className="gray-color-txt-sct-darker">{t('services.sections.section_four.top.caption')} </span>
                                        <strong>{t('services.sections.section_four.top.caption_special')}</strong>
                                    </p>
                                </BlurFade>
                            </div>
                        </div>
                    </div>
                    <div className="bottom-sct-stats ">
                        <div className="left-side-sct-stats">
                            <div className={`box-one-grid ${i18n.language === "ar" ? "ar-rtl" : ""}`}>
                                <div className="badge-one-g">
                                    {t('services.sections.section_four.bottom.title_card')}
                                </div>
                                <div className="in-box-container">
                                    <div>
                                        <h3 className="in-box-title">
                                            {t('services.sections.section_four.bottom.box.box_one.title')}
                                        </h3>
                                    </div>
                                    <div>
                                        <p className="in-box-text">{t('services.sections.section_four.bottom.box.box_one.text')}</p>
                                    </div>
                                </div>
                            </div>
                            <div className={`box-two-grid ${i18n.language === "ar" ? "ar-rtl" : ""}`}>
                            <div className="container-bottom-box">
                                    <div className="cont-in-box">
                                    <NumberTicker
                                        value={99}
                                        direction={"up"}
                                    />
                                    <span>
                                        %
                                    </span>
                                    </div>
                                    <div className="txt-box-two">
                                        <p>
                                            {t('services.sections.section_four.bottom.box.box_two.text')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="right-side-sct-stats">
                            <div className={`box-three-grid ${i18n.language === "ar" ? "ar-rtl" : ""}`}>
                                <div className="parent-three-box">
                                    <div className="cont-in-box">
                                    1.5 {t('services.sections.section_four.bottom.box.box_three.title')}
                                    </div>
                                <div className="txt-box-three">
                                    <p>
                                        {t('services.sections.section_four.bottom.box.box_three.text')}
                                    </p>
                                </div>
                                </div>
                            </div>
                            <div className={`box-four-grid ${i18n.language === "ar" ? "ar-rtl" : ""}`}>
                                <div className="container-bottom-box">
                                    <div className="cont-in-box">
                                    <NumberTicker
                                        value={100}
                                        direction={"up"}
                                    />
                                    <span>
                                        +
                                    </span>
                                    </div>
                                    <div className="txt-box-four">
                                        <p>
                                            {t('services.sections.section_four.bottom.box.box_four.text')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`customer-say-section ${i18n.language === "ar" ? "ar-rtl" : ""}`}>
                <BlurFade delay={0.25} className="section-title-container-customer-say" inView>  
                    
                        <div className="mini-title-customer-say">
                        {t('services.sections.section_five.title_card')}
                        </div>
                        <div>
                        <h2 className="section-main-title-customer-say">
                            {t('services.sections.section_five.title')}
                        </h2>
                        </div>
                        <div className="paragraph-customer-say">
                            {t('services.sections.section_five.text')}
                        </div>
                    
                </BlurFade>
                <div className="box-marquees">
                    <BlurFade delay={0.25} className="box-marquee" inView>  
                        <div className="txt-superior">
                            <div className="blockquote">
                                "
                            </div>
                            <div className="testimonial-txt">
                                <p>
                                    {t('services.sections.section_five.box_marquees.box_one.text')}
                                </p>
                            </div>
                        </div>
                        <div className="user-w-testimonial">
                            <div>
                                <img loading="lazy" className="user-picture-tst flex-default" src={avatar_cs1} alt="Avatar" />
                            </div>
                            <div className="info-user-container">
                                <div className="txt-user-name">
                                    Ricky Chain
                                </div>
                                <div className="txt-user-work">
                                    {t('services.sections.section_five.box_marquees.box_one.work')} <strong>Microsoft</strong>
                                </div>
                            </div>
                        </div>
                    </BlurFade>
                    <BlurFade delay={0.25} className="box-marquee" inView> 
                        <div className="txt-superior">
                            <div className="blockquote">
                                "
                            </div>
                            <div className="testimonial-txt">
                                <p>
                                    {t('services.sections.section_five.box_marquees.box_two.text')}
                                </p>
                            </div>
                        </div>
                        <div className="user-w-testimonial">
                            <div>
                                <img loading="lazy" className="user-picture-tst flex-default" src={avatar_cs2} alt="Avatar" />
                            </div>
                            <div className="info-user-container">
                                <div className="txt-user-name">
                                    Paco Fox
                                </div>
                                <div className="txt-user-work">
                                    {t('services.sections.section_five.box_marquees.box_two.work')} <strong>Amazon</strong>
                                </div>
                            </div>
                        </div>
                    </BlurFade>
                    <BlurFade delay={0.25} className="box-marquee" inView> 
                        <div className="txt-superior">
                            <div className="blockquote">
                                "
                            </div>
                            <div className="testimonial-txt">
                                <p>
                                    {t('services.sections.section_five.box_marquees.box_three.text')}
                                </p>
                            </div>
                        </div>
                        <div className="user-w-testimonial">
                            <div>
                                <img loading="lazy" className="user-picture-tst flex-default" src={avatar_cs1} alt="Avatar" />
                            </div>
                            <div className="info-user-container">
                                <div className="txt-user-name">
                                    Steph Rock
                                </div>
                                <div className="txt-user-work">
                                    {t('services.sections.section_five.box_marquees.box_three.work')} <strong>Nvidia</strong>
                                </div>
                            </div>
                        </div>
                    </BlurFade>
                </div>
            </div>
            <div className={`faq-section-services ${i18n.language === "ar" ? "ar-rtl" : ""}`}>
                <BlurFade delay={0.25} inView>  
                    <div className="section-title-container-faq">
                        <div className="mini-title-faq-services">
                        {t('services.sections.section_six.title_card')}
                        </div>
                        <div>
                        <h2 className="section-main-title-faq">
                            {t('services.sections.section_six.title')} <AuroraText>{t('services.sections.section_six.title_special')}</AuroraText>
                        </h2>
                        </div>
                        <div>
                            <p className="p-faq-sct">
                                {t('services.sections.section_six.text')}
                            </p>
                        </div>
                    </div>
                </BlurFade>
                <div style={{ height: `${faqContainerHeight}px`}} className="container-faq-n-ans">
                    <div className={`container-child-faqs ${selectedFAQ === 0 ? "bg-[#FAFAFA]" : ""}`}>
                        <button onClick={(e) => setSelectedFAQ((prev) => prev === 0 ? null : 0)} className="button-response-n">
                            <div className="flex-default">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={`lucide lucide-chevron-down-icon lucide-chevron-down ${selectedFAQ === 0 ? "rotate-180" : "rotate-0"} transition-transform duration-200`}><path d="m6 9 6 6 6-6"/></svg>
                            </div>
                            <div>
                                {t('services.sections.section_six.questions.question_one.text')}
                            </div>
                            
                        </button>
                        <div style={{ maxHeight: `${selectedFAQ === 0 ? `${containerHeights[0]}` : `0`}px`}} className={`transition-max-height duration-200 ease-linear txt-faq-response`}>
                            <div className="margin-2">
                                {t('services.sections.section_six.questions.question_one.answer')}
                            </div>
                        </div>
                    </div>
                    <hr className="separator" />
                    <div className={`container-child-faqs ${selectedFAQ === 1 ? "bg-[#FAFAFA]" : ""}`}>
                        <button onClick={() => setSelectedFAQ((prev) => prev === 1 ? null : 1)} className="button-response-n">
                            <div className="flex-default">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={`lucide lucide-chevron-down-icon lucide-chevron-down ${selectedFAQ === 1 ? "rotate-180" : "rotate-0"} transition-transform duration-200`}><path d="m6 9 6 6 6-6"/></svg>
                            </div>
                            <div>
                               {t('services.sections.section_six.questions.question_two.text')}
                            </div>
                        </button>
                        <div style={{ maxHeight: `${selectedFAQ === 1 ? `${containerHeights[1]}` : `0`}px`}}  className={`transition-max-height duration-200 ease-linear txt-faq-response`}>
                            <div className="margin-2">
                                {t('services.sections.section_six.questions.question_two.answer')}
                            </div>
                        </div>
                    </div>
                    <hr className="separator" />
                    <div className={`container-child-faqs ${selectedFAQ === 2 ? "bg-[#FAFAFA]" : ""}`}>
                        <button onClick={() => setSelectedFAQ((prev) => prev === 2 ? null : 2)} className="button-response-n">
                            <div className="flex-default">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={`lucide lucide-chevron-down-icon lucide-chevron-down ${selectedFAQ === 2 ? "rotate-180" : "rotate-0"} transition-transform duration-200`}><path d="m6 9 6 6 6-6"/></svg>
                            </div>
                            <div>
                                {t('services.sections.section_six.questions.question_three.text')}
                            </div>
                        </button>
                        <div style={{ maxHeight: `${selectedFAQ === 2 ? `${containerHeights[2]}` : `0`}px`}} className={`transition-max-height duration-200 ease-linear txt-faq-response`}>
                            <div className="margin-2">
                                {t('services.sections.section_six.questions.question_three.answer')}
                            </div>
                        </div>
                    </div>
                    <hr className="separator" />
                    <div className={`container-child-faqs ${selectedFAQ === 3 ? "bg-[#FAFAFA]" : ""}`}>
                        <button onClick={() => setSelectedFAQ((prev) => prev === 3 ? null : 3)} className="button-response-n">
                            <div className="flex-default">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={`lucide lucide-chevron-down-icon lucide-chevron-down ${selectedFAQ === 3 ? "rotate-180" : "rotate-0"} transition-transform duration-200`}><path d="m6 9 6 6 6-6"/></svg>
                            </div>
                            <div>
                                {t('services.sections.section_six.questions.question_four.text')}
                            </div>
                        </button>
                        <div style={{ maxHeight: `${selectedFAQ === 3 ? `${containerHeights[3]}` : `0`}px`}} className={`transition-max-height duration-200 ease-linear txt-faq-response`}>
                            <div className="margin-2">
                                {t('services.sections.section_six.questions.question_four.answer')}
                            </div>
                        </div>
                    </div>
                    <hr className="separator" />
                    <div className={`container-child-faqs ${selectedFAQ === 4 ? "bg-[#FAFAFA]" : ""}`}>
                        <button onClick={() => setSelectedFAQ((prev) => prev === 4 ? null : 4)} className="button-response-n">
                            <div className="flex-default">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={`lucide lucide-chevron-down-icon lucide-chevron-down ${selectedFAQ === 4 ? "rotate-180" : "rotate-0"} transition-transform duration-200`}><path d="m6 9 6 6 6-6"/></svg>
                            </div>
                            <div>
                                {t('services.sections.section_six.questions.question_five.text')}
                            </div>
                        </button>
                        <div style={{ maxHeight: `${selectedFAQ === 4 ? `${containerHeights[4]}` : `0`}px`}} className={`transition-max-height duration-200 ease-linear txt-faq-response`}>
                            <div className="margin-2">
                                {t('services.sections.section_six.questions.question_five.answer')}
                            </div>
                        </div>
                    </div>
                    <hr className="separator" />
                    <div className={`container-child-faqs ${selectedFAQ === 5 ? "bg-[#FAFAFA]" : ""}`}>
                        <button onClick={() => setSelectedFAQ((prev) => prev === 5 ? null : 5)} className="button-response-n">
                            <div className="flex-default">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={`lucide lucide-chevron-down-icon lucide-chevron-down ${selectedFAQ === 5 ? "rotate-180" : "rotate-0"} transition-transform duration-200`}><path d="m6 9 6 6 6-6"/></svg>
                            </div>
                            <div>
                                {t('services.sections.section_six.questions.question_six.text')}
                            </div>
                        </button>
                        <div style={{ maxHeight: `${selectedFAQ === 5 ? `${containerHeights[5]}` : `0`}px`}} className={`transition-max-height duration-200 ease-linear txt-faq-response`}>
                            <div className="margin-2">
                               {t('services.sections.section_six.questions.question_six.answer')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Services